export default {
  COMINGSOON: 'coming-soon',
  NOCHANGE: 'do-not-change',
  FINISH: 'finish-process',

  MODAL_DEPOSIT: 'deposit-modal',
};
